import { useMemo, useState } from "react";
import { employees as baseEmployees } from "../data/generated";
import type { Employee, GameState } from "../types";
import { EmployeeTable } from "../components/EmployeeTable";

interface DirectoryScreenProps {
  run: GameState;
  onBack: () => void;
}

function mutateEmployees(run: GameState): Employee[] {
  const activeYamada = run.directoryMutationIds.includes("yamada_active") || run.currentMail?.directoryMutationId === "yamada_active";
  return baseEmployees.map((employee) => {
    if (employee.id === "yamada" && activeYamada) {
      return {
        ...employee,
        department: "管理部",
        role: "管理課長",
        email: "s.yamada@to-oh.local",
        extension: "201",
        employmentStatus: "active" as const,
        retiredAt: undefined,
        notes: ["管理部責任者", "本日付で復職"]
      };
    }
    if (employee.id === "player" && run.loopCount >= 6) {
      return {
        ...employee,
        role: "元・契約監視員",
        employmentStatus: "retired" as const,
        retiredAt: "2026-07-23",
        notes: ["退職手続き完了"]
      };
    }
    return employee;
  });
}

export function DirectoryScreen({ run, onBack }: DirectoryScreenProps) {
  const [query, setQuery] = useState("");
  const rows = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return mutateEmployees(run).filter((employee) => {
      if (!normalized) return true;
      return [employee.displayName, employee.department, employee.email, employee.role]
        .some((value) => value.toLowerCase().includes(normalized));
    });
  }, [query, run]);

  return (
    <main className="document-screen app-surface">
      <header className="document-header">
        <div><div className="document-kicker">PERSONNEL DATABASE</div><h1>社員名簿</h1></div>
        <button type="button" onClick={onBack}>ポータルへ戻る</button>
      </header>
      <section className="document-body">
        <label className="search-field">
          <span>氏名・部署・メールアドレスを検索</span>
          <input value={query} onChange={(event: { target: HTMLInputElement }) => setQuery(event.target.value)} placeholder="検索語を入力" />
        </label>
        <div className="directory-summary">登録件数: {rows.length} / 更新日時: 2026/07/22 18:00</div>
        <EmployeeTable employees={rows} />
        <p className="document-note">在籍情報に相違がある場合は、情報管理部へ連絡してください。</p>
      </section>
    </main>
  );
}
